import { useMemo } from 'react';
import { Box, Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router';
import { useAlerts } from '../../hooks/useAlerts';
import { AlertForm } from './AlertsForm';
import { Loader } from '../Loader';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

export const AlertsEdit = () => {
    const { data: alerts = [], isFetched } = useAlerts();
    const { id } = useParams();
    const navigate = useNavigate();

    const handleBack = () => navigate('/alerts');

    const alert = useMemo(() => {
        if (!isFetched) return;

        return alerts.find((alert) => alert._id.toString() === id);
    }, [id, alerts, isFetched]);

    if (!alert)
        return (
            <Box sx={{ display: 'flex', minWidth: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                {!isFetched && <Loader />}
                {isFetched && (
                    <Button size="large" variant="outlined" startIcon={<NavigateBeforeIcon />} onClick={handleBack}>
                        Alert Not Found
                    </Button>
                )}
            </Box>
        );

    return <AlertForm alert={alert} />;
};
